// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 524) return "app-v2-81cb314f.css";
	// return url for filenames based on template
	return "" + ({"188":"playground","795":"canvas"}[chunkId] || chunkId) + "-v2-" + {"188":"7f409e49","272":"62868c6e","795":"7f409e49","862":"62868c6e"}[chunkId] + ".chunk.css";
};